import React from 'react';

export default function Laurels(props) {
  return (
    <div className="laurels">
      {props.white ? (
        <img
          className="img-fluid"
          src="https://cdn.foodrevolution.org/tntg/winning-laurels-nodates.png"
          alt="winning awards laurels graphic"
        />
      ) : (
        <img
          className="img-fluid"
          src="https://cdn.foodrevolution.org/tntg/winning-laurels-black-nodates.png"
          alt="winning awards laurels graphic"
        />
      )}
    </div>
  );
}
